import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMPANY_LICENSED_STATES_ACTION_TYPE } from '../actions';

const initialState = [];

const nmlsLicensesReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case COMPANY_LICENSED_STATES_ACTION_TYPE.GET_NMLS_STATES:
        return payload || initialState;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default nmlsLicensesReducer;
